import React, { Component } from "react";
import BudgetForm from "./BudgetForm/BudgetForm";
import { Button } from "rsuite";
import {Modal, ModalBody, ModalHeader} from "reactstrap";
class AgencyBudget extends Component {
  state = {
    agency_budget_id: null
  };

  componentWillMount() {
    // this.props.fetchBudget(this.props.currentAgencyID);
  }

  render() {
    let smallModal = (
      <div className="modal-container">
          <Modal
              isOpen={this.props.showSmallModal}
              fade
              size="lg"
              toggle={this.props.toggleSmallModalHandler}
              backdrop="static"
          >
              <ModalHeader toggle={this.props.toggleSmallModalHandler}>Create New Budget</ModalHeader>
              <ModalBody>
                  <BudgetForm
                      toggleSmallModalHandler={this.props.toggleSmallModalHandler}
                      values={this.props.budget.find(
                          a => a.agency_budget_id === this.state.agency_budget_id
                      )}
                      updateBudget={this.props.updateBudget}
                      agencyID={this.props.currentAgencyID}
                      addBudget={this.props.addBudget}
                  />
              </ModalBody>
          </Modal>
      </div>
    );

    return (
      <div>
          {this.props.disabled ? null :
              <div style={{textAlign: "right"}}>
                  <Button
                      color="blue"
                      className="my-2"
                      onClick={() => {
                          this.setState({agency_budget_id: null});
                          this.props.toggleSmallModalHandler();
                      }}
                  >
                      Create New Budget
                  </Button>
              </div>
          }
        {smallModal}

        <table className="table table-hover">
          <thead>
            <tr>
              <th>Budget Year</th>
              <th>Budget Name</th>
              <th>Budget Value($Mil)</th>
              <th>Expenditure Or Funding</th>
              <th>Category</th>
              <th>Description</th>
              {this.props.disabled ? null : (<th />)}
            </tr>
          </thead>
          <tbody>
            {this.props.budget.map(item => (
              <tr
                key={item.agency_budget_id}
                onClick={e => {
                  if (e.target.type !== "button") {
                    this.setState({
                      agency_budget_id: item.agency_budget_id
                    });
                    this.props.toggleSmallModalHandler();
                  }
                }}
              >
                <td>{item.agency_budget_year}</td>
                <td>{item.agency_budget_name}</td>
                <td>{item.agency_budget_value.toLocaleString()}</td>
                <td>{item.expenditure_or_funding.toLocaleString()}</td>
                <td>{item.agency_budget_category}</td>
                <td>{item.agency_budget_description}</td>
                  {this.props.disabled ? null :
                      <td>
                          <Button
                              type="button"
                              color="red"
                              onClick={() => {
                                  this.props.deleteBudget(
                                      item.agency_budget_id,
                                      this.props.currentAgencyID
                                  );
                              }}
                          >
                              Delete
                          </Button>
                      </td>
                  }
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}

export default AgencyBudget;
